import fetchAPI from '../../../utils/fetchAPI';
import type { UserTrackingData } from '../../../utils/gaTracking';

export default async function fetchUserTrackingData(xsrfToken: string): Promise<UserTrackingData | null> {
  try {
    const userData = await fetchAPI({
      url: '/identity/v2/api/user',
      xsrfToken,
    });

    return {
      encryptedId: userData.encryptedId,
      hashedEmail: userData.hashedEmail,
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Failed to fetch user tracking data:', error);
    return {};
  }
}
